export enum PropertyTypes {
    HOUSE = 'Houses',
    TOWNHOUSE = 'Townhouses',
    APTSANDCONDOS = 'Apartments and Condos',
    ALL = 'All home types'
}
